export class FlagIconHelper {

  static getFlagIconForTwoLetterIsoCode(twoLetterIsoCode) {
    let flagIcon = twoLetterIsoCode.toLowerCase();
    if (flagIcon === 'en') {
      flagIcon = 'gb';
    }
    return flagIcon;
  }
}